import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
export function getPerPage() {
  return Number(app.forum.attribute('perPage')) || 20;
}
export function isDiscussionPage() {
  return !!app.current?.matches(DiscussionPage);
}
export function getDiscussionModel() {
  return app.current?.get('discussion') ?? null;
}
export function getDiscussionId(discussion) {
  return String(discussion.id() ?? '');
}
export function getDiscussionSlug(discussion) {
  return String(discussion.slug() ?? '');
}
export function getLastPostNumber(discussion) {
  const byLast = Number(discussion.lastPostNumber() ?? 0);
  const byCount = Number(discussion.commentCount() ?? 0) + 1;
  const total = Math.max(byLast, byCount, 1);
  return Number.isFinite(total) ? total : 1;
}

/** The `near` of the current route (/d/1-slug/21 is 21); 1 on the first page and for «reply». */
export function getNearFromUrl() {
  const near = parseInt(m.route.param('near'), 10);
  return Number.isFinite(near) && near > 0 ? near : 1;
}
export function getTotalPages(discussion) {
  return Math.max(1, Math.ceil(getLastPostNumber(discussion) / getPerPage()));
}
export function getCurrentPage(totalPages) {
  const page = Math.ceil(getNearFromUrl() / getPerPage());
  return Math.min(Math.max(page, 1), totalPages);
}

/** The route of a page of the discussion, built by Flarum's own URL generator (so a subdirectory install works too). */
export function makeDiscussionPath(discussion, page) {
  const safePage = Math.max(1, page);
  return safePage <= 1 ? app.route.discussion(discussion) : app.route.discussion(discussion, (safePage - 1) * getPerPage() + 1);
}
export function navigateToDiscussionPage(discussion, page) {
  m.route.set(makeDiscussionPath(discussion, page));
}
flarum.reg.add('forumaker-magicread', 'forum/components/paginationUtils', { getPerPage: getPerPage,isDiscussionPage: isDiscussionPage,getDiscussionModel: getDiscussionModel,getDiscussionId: getDiscussionId,getDiscussionSlug: getDiscussionSlug,getLastPostNumber: getLastPostNumber,getNearFromUrl: getNearFromUrl,getTotalPages: getTotalPages,getCurrentPage: getCurrentPage,makeDiscussionPath: makeDiscussionPath,navigateToDiscussionPage: navigateToDiscussionPage, });